export class CustomLayoutField {
  Id: number;
  SectionID: number;
  DQFieldID: number;
  SpecialFieldID: number;
  AllowEdit: boolean;
  Order: number;
  Visible: boolean;
  RequiredForFilter: boolean;
  RequiredForDisplay: boolean;
  AlwaysIncludeInResults: boolean;
  SortByDefault: boolean;
  SortDirection: string;
  SortOrder: number;
  // v9
  CategoryId: number;
}
